import { Image } from '@chakra-ui/react';
import { ADVISOR_PANEL_PRIMARY_500, ADVISOR_SIDE_PANEL_Z_INDEX } from '@kintsugi/advisor-ui';
import { Button, Tooltip } from '@kintsugi/ui';
import type { ReactNode } from 'react';

import { useAdminAgent } from './use-admin-agent';
import { KIN_SIDE_TAB_BUTTON_URL } from './kin-icons';

const SIDE_TAB_Z = ADVISOR_SIDE_PANEL_Z_INDEX - 1;

// The 62x146 SVG is mostly transparent drop-shadow; the visible tab is the 34x85 box at
// (28, 25). The button covers only that box so the shadow doesn't swallow clicks on
// controls underneath, like the note composer icons.
const IMAGE_WIDTH = 62;
const IMAGE_HEIGHT = 146;
const TAB_LEFT = 28;
const TAB_TOP = 25;
const TAB_WIDTH = 34;
const TAB_HEIGHT = 85;

export function AdminAgentSideTab(): ReactNode {
  const { eligible, open, openDrawer } = useAdminAgent();

  if (!eligible || open) {
    return null;
  }

  return (
    <Tooltip content="Open Kin" positioning={{ placement: 'left' }} showArrow>
      <Button
        size="md"
        type="button"
        variant="plain"
        aria-label="Open Kin"
        onClick={() => openDrawer()}
        position="fixed"
        right={0}
        top={`calc(50% - ${IMAGE_HEIGHT / 2 - TAB_TOP}px)`}
        zIndex={SIDE_TAB_Z}
        w={`${TAB_WIDTH}px`}
        minW={`${TAB_WIDTH}px`}
        h={`${TAB_HEIGHT}px`}
        p={0}
        borderWidth={0}
        overflow="visible"
        cursor="pointer"
        bg="transparent"
        borderRadius={0}
        transition="filter 0.15s ease"
        display="flex"
        alignItems="center"
        justifyContent="center"
        _hover={{ filter: 'brightness(0.96)' }}
        _focusVisible={{
          outline: '2px solid',
          outlineColor: ADVISOR_PANEL_PRIMARY_500,
          outlineOffset: '2px',
        }}
      >
        <Image
          src={KIN_SIDE_TAB_BUTTON_URL}
          alt=""
          position="absolute"
          top={`${-TAB_TOP}px`}
          left={`${-TAB_LEFT}px`}
          w={`${IMAGE_WIDTH}px`}
          h={`${IMAGE_HEIGHT}px`}
          maxW="none"
          pointerEvents="none"
          draggable={false}
          aria-hidden
        />
      </Button>
    </Tooltip>
  );
}
